

import { Vue, Component, Prop } from 'vue-property-decorator'

import ProjectItem from './ProjectItem.vue';
import ProgressItem from './ProgressItem.vue';
import CircleProgressItem from './CircleProgressItem.vue';
import TimeLineItem from './TimeLineItem.vue';
import ActivityItem from './ActivityItem.vue';
import AddActivityItem from './AddActivityItem.vue';
@Component({
    components: {
        CircleProgressItem,
        ProjectItem,
        TimeLineItem,
        ProgressItem,
        ActivityItem,
        AddActivityItem
    },
})
export default class CollapseItem extends Vue {
    @Prop({ type: Array, default: null }) readonly weekDates!: any[];
    @Prop({ type: Array, default: null }) readonly quarterMonths!: any[];
    @Prop({ type: Array, default: null }) readonly weeks!: any[];
    @Prop({ type: Boolean, default: null }) readonly isDays!: boolean;
    @Prop({ type: Boolean, default: null }) readonly isMonths!: boolean;
    @Prop({ type: Boolean, default: null }) readonly isWeeks!: boolean;
    @Prop({ type: String, default: null }) readonly columnSpan!: string;

    isOpened: boolean = false;

    toggleCollapse(value: boolean) {
        this.isOpened = value;
    }

}
